export enum Language {
  Arabic=1,
  English=2,  
  Urdu=3,  
};
